import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Footer from "../components/Footer";
import fetchTodos from "../redux/todos/thunk/fetchTodos";
import Todo from "./Todo";

export default function TodoList() {
    const todos = useSelector((state) => state.todos);
    const filters = useSelector((state) => state.filters);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(fetchTodos);
    }, [dispatch]);

    // const filterByStatus = (todo) => {
    //     const { status } = filters;
    //     switch (status) {
    //         case "Complete":
    //             return todo.completed;

    //         case "Incomplete":
    //             return !todo.completed;

    //         default:
    //             return true;
    //     }
    // };

    const filterByColors = (todo) => {
        const { colors } = filters;
        if (colors.length > 0) {
            return colors.includes(todo?.color);
        }
        return true;
    };

    const filterByIncomplete = (todo) => !todo.completed;
    const filterByComplete = (todo) => todo.completed;

    return (
        <div className="mt-2 text-gray-700 text-sm max-h-[300px] overflow-y-auto">
            <p className="text-gray-500 text-xs mb-1 text-center">
                Incomplete Tasks :
            </p>
            {todos
                // .filter(filterByStatus)
                .filter(filterByIncomplete)
                .filter(filterByColors)
                .map((todo) => (
                    <Todo todo={todo} key={todo.id} />
                ))}
            <Footer />
            <hr className="mt-4" />
            <p className="text-gray-500 text-xs mb-1 mt-3 text-center">
                Completed Tasks :
            </p>
            {todos.filter(filterByComplete).map((todo) => (
                <Todo todo={todo} key={todo.id} isCompleted />
            ))}
        </div>
    );
}
